module.exports = __webpack_public_path__ + "static/img/fill-success.4e426f07.svg";